/**
 * VSB Verkoop — Vue IIFE voor column-left (mount op #vsb-vue-column-left).
 */
import { createApp } from 'vue';
import ColumnLeftApp from '../features/column-left/ColumnLeftApp.vue';

const mountSelector = '#vsb-vue-column-left';

function bootColumnLeftWidget() {
  const el = document.querySelector(mountSelector);
  if (!el || el.dataset.vsbVueAutostart === '0') {
    return;
  }
  createApp(ColumnLeftApp).mount(el);
  document.documentElement.classList.add('vsb-column-left--vue-ready');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootColumnLeftWidget);
} else {
  bootColumnLeftWidget();
}
